import React, { useState } from "react";
import HomeColourChangeText from "./HomeColourChange";
import AboutHeadSection from "./AboutHeadSection";
import AboutClientText from "./AboutClientText";
import CardTopMarque from "./CardTopMarque";
import CardBottomMarque from "./CardBottomMarque";
import Timeline from "./timeline/Timeline";
import ScroolSticky from "./scroolSticky/ScroolSticky";
import { useQuery } from "react-query";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import BoxScrollRotate from "./cubebox/CubeBox";
import { motion } from "motion/react";
import PageTitleCard from "../../templates/PageTitleCard";
import PageHeading from "../../../templates/PageHeading";
import useGetData from "../../../../hooks/apihooks/useGetData";
import SubHeadingText from "../../../common/SubHeadingText";
import RightArrow from "../../../templates/RightArrow";
import BackHome from "../../../templates/BackHome";
import CurrentPath from "../../../templates/CurrentPath";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ScrollTriggered from "./newanimation/NewAnimation";
const About = () => {
  const [colourText, setColourText] = useState({
    heading: "",
    sub_head: "",
    content: "",
  });

  const { data, isLoading: textloading } = useQuery({
    queryKey: "getallegacy",
    queryFn: () =>
      axios.get(`${BASEURL}legacy`).then((res) => {
        return res?.data;
      }),
    onSuccess: (response) => {
      setColourText({
        heading: response[0].heading,
        sub_head: response[0].sub_head,
        content: response[0].content,
      });
    },
  });

  const {
    data: cubeData,
    isLoading,
    isError,
  } = useGetData("core-values", "getAllCoreValue");
  return (
    <>
      <PageTitleCard>
        <PageHeading>About</PageHeading>
        <div className="flex justify-evenly items-center">
          <BackHome /> <RightArrow /> <CurrentPath>About</CurrentPath>
        </div>
      </PageTitleCard>

      <div className="md:px-4   relative py-8 max-sm:px-8">
        <div className="mx-auto container">
          <SubHeadingText>About us</SubHeadingText>
        </div>
        <div className="py-8">
          {/* <BoxScrollRotate datas={cubeData} />
        <div style={{ height: "200vh" }}></div> */}
          <ScrollTriggered datas={cubeData} />
          <HomeColourChangeText
            title1={colourText.heading}
            title2={colourText.sub_head}
            para={colourText.content}
          />

          <AboutHeadSection />
          <ScroolSticky />
          <Timeline />

          <AboutClientText />
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: false, amount: 0.5 }}
            className="marque-container"
          >
            <CardTopMarque />
            <CardBottomMarque />
          </motion.div>
        </div>
      </div>
    </>
  );
};

export default About;
